module.exports = __webpack_public_path__ + "static/media/Quirinus Quirrell 2.19f1941d.jpg";